export const questionsFive = [
  {
    id: 1,
    question: "Choose the word which is different from the rest.",
    answer: "Potassium",
    options: ["Potassium", "Silicon", "Zirconium", "Gallium"],
    explanations: [
      "All except Potassium are metals used in semiconductor devices.",
    ],
  },
  {
    id: 2,
    question: "Choose the word which is different from the rest.",
    answer: "Chalk",
    options: ["Tea", "Cinchona", "Cardamom", "Chalk"],
    explanations: ["All except Chalk are obtained from crops."],
  },
  {
    id: 3,
    question: "Choose the word which is different from the rest.",
    answer: "Park",
    options: ["Hangar", "Platform", "Dock", "Park"],
    explanations: [
      "All except Park are halting places of various transport means.",
    ],
  },
  {
    id: 4,
    question: "Choose the word which is different from the rest.",
    answer: "Swan",
    options: ["Sparrow", "Swan", "Parrot", "Koel"],
    explanations: ["Swan is the only water bird in the group."],
  },
  {
    id: 5,
    question: "Choose the word which is different from the rest.",
    answer: "Sharp",
    options: ["Tall", "Huge", "Thin", "Sharp"],
    explanations: ["All except Sharp are related to dimension."],
  },
  {
    id: 6,
    question:
      "Rasik walked 20 m towards the north. Then he turned right and walks 30 m. Then he turns right and walks 35 m. Then he turns left and walks 15 m. Finally, he turns left and walks 15 m. In which direction and how many meters is he from the starting position?",
    answer: "45 m East",
    options: ["15 m West", "30 m East", "30 m West", "45 m East"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 7,
    question:
      "Starting from point X, Jayant walked 15 m towards west. He turned left and walked 20 m. He then turned left and walked 15 m. After this, he turned to his right and walked 12 m. How far and in which directions is now Jayant from X?",
    answer: "32 m, South",
    options: ["32 m, South", "47 m, East", "42 m, North", "27 m, South"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 8,
    question:
      "One evening before sunset Rekha and Hema were talking to each other face to face. If Hema's shadow was exactly to the right of Hema, which direction was Rekha facing?",
    answer: "South",
    options: ["North", "South", "East", "Data is inadequate"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 9,
    question:
      "A boy rode his bicycle Northward, then turned left and rode 1 km and again turned left and rode 2 km. He found himself 1 km west of his starting point. How far did he ride northward initially?",
    answer: "2 km",
    options: ["1 km", "2 km", "3 km", "5 km"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 10,
    question:
      "K is 40 m South-West of L. If M is 40 m South-East of L, then M is in which direction of K?",
    answer: "East",
    options: ["East", "West", "North-East", "South"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 11,
    question: "REASON : SFBTPO :: THINK : ?",
    answer: "UIJOL",
    options: ["SGHMJ", "UIJOL", "UHNKI", "UJKPM"],
    explanations: [
      "Increase one in the position of letters of first to get second.",
    ],
  },
  {
    id: 12,
    question: "Carbon : Diamond :: Corundum : ?",
    answer: "Ruby",
    options: ["Garnet", "Ruby", "Pukhraj", "Pearl"],
    explanations: [
      "As Diamond is made of Carbon similarly Ruby is made of Corundum.",
    ],
  },
  {
    id: 13,
    question: "Architect : Building :: Sculptor : ?",
    answer: "Statue",
    options: ["Museum", "Stone", "Chisel", "Statue"],
    explanations: [
      "As 'Architect' makes 'Building' similarly 'Sculptor' makes 'Statue'.",
    ],
  },
  {
    id: 14,
    question: "Conference : Chairman :: Newspaper : ?",
    answer: "Editor",
    options: ["Reporter", "Distributor", "Printer", "Editor"],
    explanations: [
      "As Chairman is the highest authority in a conference similarly Editor is in Newspaper.",
    ],
  },
  {
    id: 15,
    question: "Safe : Secure :: Protect : ?",
    answer: "Guard",
    options: ["Lock", "Sure", "Guard", "Conserve"],
    explanations: [
      "As safe and secure have the same meaning, in the same way, protect and guard have the same meaning.",
    ],
  },
  {
    id: 16,
    question: "1, 1, 4, 8, 9, 27, 16, ?",
    answer: "64",
    options: ["32", "64", "81", "256"],
    explanations: [
      "The series consists of squares and cubes of consecutive natural numbers. So, missing term = 4 cube = 64.",
    ],
  },
  {
    id: 17,
    question: "1, 2, 3, 6, 9, 18, ?, 54",
    answer: "27",
    options: ["18", "27", "36", "81"],
    explanations: [
      "The pattern is x 2, x 3/2, x 2, x 3/2, x 2,.....So, missing term = 18 x 3/2 = 27.",
    ],
  },
  {
    id: 18,
    question: "6, 13, 25, 51, 101, ?",
    answer: "203",
    options: ["201", "202", "203", "205"],
    explanations: [
      "The pattern is x 2 + 1, x 2 - 1, x 2 + 1, x 2 - 1,.....So, missing term = 101 x 2 + 1 = 203.",
    ],
  },
  {
    id: 19,
    question: "2, 3, 5,7,11,?, 17",
    answer: "13",
    options: ["12", "13", "14", "15"],
    explanations: [
      "Clearly, the given series consists of prime numbers starting from 2. So, the missing term is the prime number after 11, which is 13.",
    ],
  },
  {
    id: 20,
    question: "6, 12, 21, ?, 48",
    answer: "33",
    options: ["33", "38", "40", "45"],
    explanations: [
      "The pattern is + 6, + 9, + 12, + 15,.....So, missing term = 21 + 12 = 33.",
    ],
  },
  {
    id: 21,
    question:
      "Pointing to a photograph Lata says, 'He is the son of the only son of my grandfather.' How is the man in the photograph related to Lata?",
    answer: "Brother",
    options: ["Brother", "Uncle", "Cousin", "Data is inadequate"],
    explanations: [
      "The man in the photograph is the son of the only son of Lata's grandfather i.e., the man is the son of Lata's father. Hence, the man is the brother of Lata.",
    ],
  },
  {
    id: 22,
    question:
      "If A + B means A is the brother of B; A x B means A is the son of B, and A % B means B is the daughter of A then which of the following means M is the maternal uncle of N?",
    answer: "None of these",
    options: ["M + O x N", "M % O x N + P", "M + O % N", "None of these"],
    explanations: ["Because the sex of O is not known."],
  },
  {
    id: 23,
    question:
      "Pointing to a photograph. Bajpai said, 'He is the son of the only daughter of the father of my brother.' How Bajpai is related to the man in the photograph?",
    answer: "Maternal Uncle",
    options: ["Nephew", "Brother", "Father", "Maternal Uncle"],
    explanations: [
      "The man in the photo is the son of the sister of Bajpai. Hence, Bajpai is the maternal uncle of the man in the photograph.",
    ],
  },
  {
    id: 24,
    question:
      "Deepak said to Nitin, 'That boy playing with the football is the younger of the two brothers of the daughter of my father's wife.' How is the boy playing football related to Deepak?",
    answer: "Brother",
    options: ["Son", "Brother", "Cousin", "Brother-in-law"],
    explanations: [
      "Father's wife → mother. Hence, the daughter of the mother means sister, and the sister's younger brother means brother. Therefore, the boy is the brother of Deepak.",
    ],
  },
  {
    id: 25,
    question:
      "Veena who is the sister-in-law of Ashok is the daughter-in-law of Kalyani. Dheeraj is the father of Sudeep who is the only brother of Ashok. How Kalyani is related to Ashok?",
    answer: "None of these",
    options: ["Mother-in-law", "Aunt", "Wife", "None of these"],
    explanations: [
      "Ashok is the only brother of Sudeep and Veena is the sister-in-law of Ashok. Hence Veena is the wife of Sudeep. Kalyani is the mother-in-law of Veena. Kalyani is the mother of Ashok.",
    ],
  },

  {
    id: 26,
    question:
      "Arrange the words given below in a meaningful sequence. 1.Leaf	 2.Fruit	3.Stem  4.Root	5.Flower	",
    answer: "4, 3, 1, 5, 2",
    options: [
      "3, 4, 5, 1, 2",
      "4, 3, 1, 5, 2",
      "4, 1, 3, 5, 2",
      "4, 3, 1, 2, 5",
    ],
    explanations: [
      "The correct order is : 4.Root	3.Stem	 1.Leaf	  5.Flower	 2.Fruit",
    ],
  },
  {
    id: 27,
    question:
      "Arrange the words given below in a meaningful sequence. 1.Nation	 2.Village	3.City  4.District	5.State",
    answer: "2, 3, 4, 5, 1",
    options: [
      "2, 3, 4, 5, 1",
      "2, 3, 4, 1, 5",
      "1, 3, 5, 4, 2",
      "1, 2, 3, 4, 5",
    ],
    explanations: [
      "The correct order is : 2.Village  3.City  4.District	 5.State	 1.Nation",
    ],
  },
  {
    id: 28,
    question:
      "Arrange the words given below in a meaningful sequence. 1.Caste	 2.Family	3.Newly married Couple  4.Clan	 5.Species	",
    answer: "3, 2, 1, 4, 5",
    options: [
      "2, 3, 1, 4, 5",
      "3, 4, 5, 1, 2",
      "3, 2, 1, 4, 5",
      "4, 5, 3, 2, 1",
    ],
    explanations: [
      "The correct order is : 3.Newly married Couple	2.Family	1.Caste	 4.Clan	 5.Species",
    ],
  },

  {
    id: 29,
    question:
      "Arrange the words given below in a meaningful sequence. 1.Cut  2.Put on	3.Mark  4.Measure  5.Tailor",
    answer: "4, 3, 1, 5, 2",
    options: [
      "3, 1, 5, 4, 2",
      "2, 4, 3, 1, 5",
      "1, 3, 2, 4, 5",
      "4, 3, 1, 5, 2",
    ],
    explanations: [
      "The correct order is : 4.Measure	3.Mark	1.Cut	5.Tailor	2.Put on",
    ],
  },
  {
    id: 30,
    question:
      "Arrange the words given below in a meaningful sequence. 1. House	2. Street	3. Room  4. Town	5. District	",
    answer: "3, 1, 2, 4, 5",
    options: [
      "3, 2, 1, 4, 5",
      "3, 1, 4, 2, 5",
      "3, 1, 2, 4, 5",
      "3, 1, 2, 5, 4",
    ],
    explanations: [
      "The correct order is : 3.Room	1.House	 2.Street	4.Town	5.District",
    ],
  },
  {
    id: 31,
    question: "Which one of the following a 'Drama' must have?",
    answer: "Story",
    options: ["Actors", "Story", "Sets", "Director"],
    explanations: ["A drama can't be played without a story."],
  },
  {
    id: 32,
    question:
      "A boy is sitting in the back seat of a car. When the driver suddenly starts moving the car (in the forward direction), the boy experiences a backward force?",
    answer: "Always",
    options: ["Always", "Never", "Often", "Sometimes"],
    explanations: [
      "When a car suddenly starts the lower part of the boy's body will be in motion while his upper will be at rest. Hence he will always experience backward force.",
    ],
  },
  {
    id: 33,
    question: "Which one of the following is always found in 'Wonder'?",
    answer: "Astonishment",
    options: ["Crowd", "Lumber", "Astonishment", "Rustic"],
    explanations: [
      "Astonishment means amazement, whenever there is a wonder there is amazement.",
    ],
  },
  {
    id: 34,
    question: "Disclosure always involves",
    answer: "Secrets",
    options: ["Agents", "Display", "Exposition", "Secrets"],
    explanations: [
      "Disclosure means revealing, and only secrets can be revealed.",
    ],
  },
  {
    id: 35,
    question: "A bulb always has",
    answer: "Filament",
    options: ["Glass", "Current", "Filament", "Light"],
    explanations: ["Filament is the essential part in bulb."],
  },
  {
    id: 36,
    question: "Especially skilled in story telling is called",
    answer: "Raconteur",
    options: ["Raconteur", "Elegy", "Clientele", "Forgery"],
    explanations: [
      "Raconteur - a person who tells anecdotes in a skillful and amusing way.",
      "Elegy - a poem of serious reflection, typically a lament for the dead.",
      "Clientele - the customers of a shop, bar, or place of entertainment.",
      "Forgery - the action of forging a copy or imitation of a document, signature, banknote, or work of art.",
    ],
  },
  {
    id: 37,
    question: "Fear of loneliness is called",
    answer: "Eremophobia",
    options: ["Sciophobia", "Cremnophobia", "Atelophobia", "Eremophobia"],
    explanations: [
      "Sciophobia is the fear of shadows.",
      "Cremnophobia is the fear of steep cliffs.",
      "Atelophobia is defined as the fear of not doing something right or the fear of not being good enough.",
      "Eremophobia is the fear of being oneself or being alone or of loneliness.",
    ],
  },
  {
    id: 38,
    question: "A brave, noble-minded or chivalrous man",
    answer: "Gallant",
    options: ["Handsome", "Robust", "Gallant", "Reckless"],
    explanations: [
      "Handsome - (of a man) good-looking",
      "Robust - strong and healthy; vigorous",
      "Gallant - brave, spirited, noble-minded, or chivalrous",
      "Reckless - doing something dangerous and not worrying about the risks and the possible results",
    ],
  },
  {
    id: 39,
    question: "One who cannot be corrected is called",
    answer: "Incorrigible",
    options: ["Incurable", "Incorrigible", "Hardened", "Vulnerable"],
    explanations: [
      "Incurable - incapable of being cured or treated.",
      "Incorrigible - not able to be changed or reformed.",
      "Hardened - having become or been made hard or harder.",
      "Vulnerable - exposed to the possibility of being attacked or harmed, either physically or emotionally.",
    ],
  },
  {
    id: 40,
    question:
      "How many 9's are followed by and preceded by numbers divisible by 2? 8965359683496526973729413794173498453976153195742968532957489451",
    answer: "6",
    options: ["12", "6", "8", "10"],
    explanations: [
      "In the given series, there are six 9's followed by and preceded by a number divisible by 2.",
    ],
  },
];
